import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth/AuthContext';
import { ProtectedRoute } from '@/lib/auth/ProtectedRoute';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { OutletsPage } from '@/pages/outlets/OutletsPage';
import { OutletDetailPage } from '@/pages/outlets/OutletDetailPage';
import { NewOutletPage } from '@/pages/outlets/NewOutletPage';
import { FramesPage } from '@/pages/frames/FramesPage';
import { FrameCategoriesPage } from '@/pages/frame-categories/FrameCategoriesPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { CashiersPage } from '@/pages/cashiers/CashiersPage';
import { NewCashierPage } from '@/pages/cashiers/NewCashierPage';
import { EditCashierPage } from '@/pages/cashiers/EditCashierPage';
import { CategoriesPage } from '@/pages/categories/CategoriesPage';
import { ProductsPage } from '@/pages/products/ProductsPage';
import { RevenuePage } from '@/pages/revenue/RevenuePage';
import { TransactionsPage } from '@/pages/transactions/TransactionsPage';
import { BrandingPage } from '@/pages/branding/BrandingPage';
import { CaptureSettingsPage } from '@/pages/capture/CaptureSettingsPage';
import { VouchersPage } from '@/pages/vouchers/VouchersPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="outlets">
              <Route index element={<OutletsPage />} />
              <Route path="new" element={<NewOutletPage />} />
              <Route path=":outletId" element={<OutletDetailPage />} />
            </Route>
            <Route path="frames" element={<FramesPage />} />
            <Route path="frame-categories" element={<FrameCategoriesPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="cashiers">
              <Route index element={<CashiersPage />} />
              <Route path="new" element={<NewCashierPage />} />
              <Route path=":userId/edit" element={<EditCashierPage />} />
            </Route>
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="revenue" element={<RevenuePage />} />
            <Route path="transactions" element={<TransactionsPage />} />
            <Route path="branding" element={<BrandingPage />} />
            <Route path="capture" element={<CaptureSettingsPage />} />
            <Route path="vouchers" element={<VouchersPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
